import {
  GET_ANOMALIES_CYCLE,
  GET_ANOMALIES_CYCLE_ERROR,
  GET_ANOMALIES_CYCLE_SUCCESS,
  GET_TRUCK_GPS_POINTS,
  GET_TRUCK_GPS_POINTS_ERROR,
  GET_TRUCK_GPS_POINTS_SUCCESS,
  CLEAR_TRUCK_GPS_POINTS,
} from './CycleAnomaly.actions';

const initialState = {
  data: [],
  loading: false,
  error: undefined,
  gpsPoints: {
    data: [],
    loading: false,
    error: null,
    count: 0,
    patente: null,
    fecha_inicio: null,
    fecha_termino: null,
  },
};

/**
 * The Anomalies Cycle Reducer.
 */
const anomaliesCycleReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ANOMALIES_CYCLE: {
      return { ...state, loading: true, error: undefined };
    }
    case GET_ANOMALIES_CYCLE_ERROR: {
      return { ...state, loading: false, error: payload.error };
    }
    case GET_ANOMALIES_CYCLE_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: payload.data,
      };
    }
    case GET_TRUCK_GPS_POINTS: {
      return {
        ...state,
        gpsPoints: {
          ...state.gpsPoints,
          loading: true,
          error: null,
        },
      };
    }
    case GET_TRUCK_GPS_POINTS_SUCCESS: {
      return {
        ...state,
        gpsPoints: {
          data: payload.data,
          loading: false,
          error: null,
          count: payload.count,
          patente: payload.patente,
          fecha_inicio: payload.fecha_inicio,
          fecha_termino: payload.fecha_termino,
        },
      };
    }
    case GET_TRUCK_GPS_POINTS_ERROR: {
      return {
        ...state,
        gpsPoints: {
          ...state.gpsPoints,
          loading: false,
          error: payload.error,
        },
      };
    }
    case CLEAR_TRUCK_GPS_POINTS: {
      return {
        ...state,
        gpsPoints: {
          data: [],
          loading: false,
          error: null,
          count: 0,
          patente: null,
          fecha_inicio: null,
          fecha_termino: null,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export default anomaliesCycleReducer;
